import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Row, Col } from "reactstrap";

function Configurations() {
  // State to track the individual switch statuses
  const [switchState, setSwitchState] = useState({
    randomShuffling: false,
    disableCopyPaste: false,
    fullscreenMode: false,
    recordScreening: false,
    assessmentDuration: false,
    extendTime: false,
    expirationDate: false,
  });

  // Styles for the switches
  const switchStyles = {
    checked: {
      backgroundColor: "#28a745", // Green color when checked
      borderColor: "#28a745", // Green border when checked
    },
    unchecked: {
      backgroundColor: "#ccc", // Default gray color
      borderColor: "#ccc", // Default gray border
    },
  };

  // Handle the change for each switch
  const handleSwitchChange = (switchKey) => {
    setSwitchState((prevState) => ({
      ...prevState,
      [switchKey]: !prevState[switchKey],
    }));
  };

  return (
    <Form>
      <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          style={
            switchState.randomShuffling
              ? switchStyles.checked
              : switchStyles.unchecked
          }
          checked={switchState.randomShuffling}
          onChange={() => handleSwitchChange("randomShuffling")}
        />
        <Label check>Random Questions Shuffling</Label>
      </FormGroup>

      <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          style={
            switchState.disableCopyPaste
              ? switchStyles.checked
              : switchStyles.unchecked
          }
          checked={switchState.disableCopyPaste}
          onChange={() => handleSwitchChange("disableCopyPaste")}
        />
        <Label check>Disable copy/paste functions</Label>
      </FormGroup>

      <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          style={
            switchState.fullscreenMode
              ? switchStyles.checked
              : switchStyles.unchecked
          }
          checked={switchState.fullscreenMode}
          onChange={() => handleSwitchChange("fullscreenMode")}
        />
        <Label check>Fullscreen mode</Label>
      </FormGroup>

      <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          style={
            switchState.recordScreening
              ? switchStyles.checked
              : switchStyles.unchecked
          }
          checked={switchState.recordScreening}
          onChange={() => handleSwitchChange("recordScreening")}
        />
        <Label check>Record Screening</Label>
      </FormGroup>

      <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          style={
            switchState.assessmentDuration
              ? switchStyles.checked
              : switchStyles.unchecked
          }
          checked={switchState.assessmentDuration}
          onChange={() => handleSwitchChange("assessmentDuration")}
        />
        <Label check>Assessment Duration</Label>
      </FormGroup>

      {/* Input Fields for Hours and Minutes (Enabled/Disabled based on the switch state) */}
      <Row>
        <Col>
          <FormGroup>
            <Label for="hours">Hours</Label>
            <Input
              type="number"
              name="hours"
              id="hours"
              style={{ width: "60px" }} // Adjust width as needed
              size="sm"
              disabled={!switchState.assessmentDuration} // Disabled if the switch is off
            />
          </FormGroup>
        </Col>

        <Col>
          <FormGroup>
            <Label for="minutes">Minutes</Label>
            <Input
              type="number"
              name="minutes"
              id="minutes"
              style={{ width: "60px" }} // Adjust width as needed
              size="sm"
              disabled={!switchState.assessmentDuration} // Disabled if the switch is off
            />
          </FormGroup>
        </Col>
      </Row>

      {/* <FormGroup switch>
        <Input
          type="switch"
          role="switch"
          style={switchState.extendTime ? switchStyles.checked : switchStyles.unchecked}
          checked={switchState.extendTime}
          onChange={() => handleSwitchChange('extendTime')}
        />
        <Label check>Extend Time</Label>
      </FormGroup> */}
      <Row>
        <Col>
          <FormGroup switch>
            <Input
              type="switch"
              role="switch"
              style={
                switchState.expirationDate
                  ? switchStyles.checked
                  : switchStyles.unchecked
              }
              checked={switchState.expirationDate}
              onChange={() => handleSwitchChange("expirationDate")}
            />
            <Label check>Assessment Expiration Date</Label>
          </FormGroup>
        </Col>

        {/* Calendar Picker for Expiration Date (Enabled/Disabled based on expirationDate switch) */}
        <Col>
          <FormGroup>
            <Input
              type="date"
              name="expirationDate"
              id="expirationDate"
              style={{ width: "150px" }}
              size="sm"
              disabled={!switchState.expirationDate}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
}

export default Configurations;
